import { useEffect } from 'react'
import { supabase } from '../supabaseClient'

export default function SitemapPage() {
  useEffect(() => {
    const fetchSitemap = async () => {
      try {
        const [{ data: posts }, { data: cases }] = await Promise.all([
          supabase.from('posts').select('slug,updated_at').eq('status', 'published'),
          supabase.from('cases').select('slug,updated_at').eq('status', 'published'),
        ])

        const baseUrl = 'https://orkentecnologia.com.br'

        let xml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">`

        const addUrl = (loc, lastmod, priority) => {
          xml += `
  <url>
    <loc>${loc}</loc>`
          if (lastmod) xml += `
    <lastmod>${lastmod.slice(0, 10)}</lastmod>`
          xml += `
    <priority>${priority}</priority>
  </url>`
        }

        addUrl(`${baseUrl}/`, new Date().toISOString(), '1.0')
        addUrl(`${baseUrl}/blog`, new Date().toISOString(), '0.8')
        addUrl(`${baseUrl}/cases`, new Date().toISOString(), '0.8')

        posts?.forEach((p) => addUrl(`${baseUrl}/blog/${p.slug}`, p.updated_at, '0.7'))
        cases?.forEach((c) => addUrl(`${baseUrl}/cases/${c.slug}`, c.updated_at, '0.7'))

        xml += '\n</urlset>'

        document.open()
        document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"/></head><body><pre>${xml.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</pre></body></html>`)
        document.close()
      } catch (err) {
        console.error('Erro ao carregar sitemap:', err)
        document.body.innerHTML = '<pre>Erro ao carregar sitemap</pre>'
      }
    }
    fetchSitemap()
  }, [])

  return null
}
